/* eslint-disable camelcase */
/* global G, PLATFORM */
import { asyncPipeSpread } from 'lib/util'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import routeComposition from 'trait/composition/route'

/**
 * Attempts to obtain the OIDC data from the server, which is required to perform the OAuth
 * redirection.
 *
 * @type {Gaia.AppModule.ActionPartial}
 */
const obtainOAuthData = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { version } = model[G.PROPS]
  const url = `/api/v${version}/ext-auth/oidc`

  try {
    model[G.STATE].oauth = await model[G.ADAPTER][G.HTTP].get({ url })
  } catch (e) {
    console.error(e)
  }

  return [components, ...args]
}

/**
 * Redirects to the external OAuth page with the correct payload if the setting is enabled
 * and the server responded with the correct data
 *
 * @type {Gaia.AppModule.ActionPartial}
 */
export const redirectToOAuth = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { oauth } = model[G.STATE]

  const { authz_url,
    oidc_payload: {
      [`redirect_uri_${PLATFORM}`]: redirect_uri,
      client_id,
      scope,
      nonce,
      response_type,
      state,
      code_challenge,
      code_challenge_method,
    } = {} } = oauth || {}

  const params = {
    redirect_uri,
    client_id,
    scope,
    nonce,
    response_type,
    state,
    code_challenge,
    code_challenge_method,
  }

  // if (PLATFORM === 'web') {
  //   module[G.ADAPTER][G.ROUTER].open({ url: authz_url, params })
  // }
  //
  // if (PLATFORM === 'mobile') {
  //   const moduleState = module[G.STATE]
  //   moduleState[G.ROUTE] = routeComposition(null, module[G.ACTIONS].external._name)
  //   await redirectSequence(module)({ url: authz_url, params })
  // }
  const moduleState = module[G.STATE]
  moduleState[G.ROUTE] = routeComposition(null, module[G.ACTIONS].external._name)
  await redirectSequence(module)({ url: authz_url, params })

  return [components, ...args]
}

export default module => () => (...args) => asyncPipeSpread(
  obtainOAuthData(module),
  redirectToOAuth(module),
  (components, ...argv) => argv,
)(args)
